import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "semantic-ui-react"
import shop from "shop/shop"
import { observer } from "mobx-react"
import { trackAddToWishlist } from "components/tracking/Tracking";

@observer
class ButtonLove extends Component {
  
  state = {
    list: false
  }
  
  handleClick = async () => {
    const { product } = this.props
    //console.log("ButtonLove.handleClick", product, shop.orderlist.lists, shop.orderlist.lists.Standard)
    if(shop.orderlist && shop.orderlist.lists && shop.orderlist.lists.Standard && shop.orderlist.lists.Standard.title == "Standard" && shop.store.orderlist.currentList == false){
      console.log("Setting current list to Standard", shop.orderlist.lists.Standard)
      await shop.store.orderlist.setCurrentList( shop.orderlist.lists.Standard )
    }
    if ( shop.store.orderlist.currentList ) {
      if ( shop.store.orderlist.currentList && product ) {
        shop.store.orderlist.currentList.toggle( product )
        shop.store.orderlist.currentList.save(  )
        // shop.toast( `${product.count}x ${product.title} auf Merkliste ${name !== "Merkliste" ? name : ""}`, "info", false, "bottom" )
      }
      return
    }
    trackAddToWishlist(product.map_id, product.title)
    shop.store.orderlist.toggleSelectionModal( product )
  }
  
  render() {
    const { currentList } = shop.store.orderlist
    const { items } = currentList
    const { list } = this.state
    let { as, product, children, elementActive, elementInActive } = this.props
    if ( !elementActive ) elementActive = children
    if ( !elementInActive ) elementInActive = children
    
    let onList = items && items.get( product.map_id )
    // let activeClass = (list.contains( product ) ? "active" : false)
    let activeClass = ""
    if ( onList ) {
      activeClass = "active"
    }
    let {  circular = true, basic = true, ...rest } = this.props
  
    if ( as ) {
      let Element = as
      return <Element
        className={`${this.props.className} ${activeClass}`}
        onClick={this.handleClick}
        {...rest} >{activeClass ? <span>{elementActive}</span> : <span>{elementInActive}</span>}</Element>
    }
    
    return (
      <Button style={{border: "none", backgroundColor: "transparent"}}
        className={`btn-love ${activeClass} ${this.props.className}`}
        onClick={this.handleClick}>
        {activeClass ? <span>{elementActive}</span> : <span>{elementInActive}</span>}</Button>)
  }
}

ButtonLove.propTypes = {
  product: PropTypes.object.isRequired,
  list: PropTypes.object.isRequired,
  children: PropTypes.any,
  elementActive: PropTypes.any,
  elementInActive: PropTypes.any,
}

export default ButtonLove



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Button/ButtonLove.js